const experiences = [
  {
    role: "Front-end Developer - Internship",
    date: "03.2026 - 09.2026",
    company: "Digital Competence Foundation",
    description:
      "Developing modern, responsive web interfaces using Next.js, Tailwind CSS, and Radix UI components within a dedicated development team. Integrating Sanity Studio as a headless CMS for dynamic content management.",
  },
  {
    role: "Web Developer - Freelance",
    date: "03.2023 - present",
    company: "LunarisWeb.pl",
    description:
      "Delivering custom websites and user interfaces for B2B clients utilizing Next.js, React.js, and Tailwind CSS or on clients request Wordpress and PHP. Developed commercial solutions and graphic designs for clients including AI Create, Bielik AI and many more.",
  },
];

const Experience = () => {
  return (
    <section id="experience" className="mx-auto flex flex-col gap-4 p-4">
      <h4 className="text-primary text-xl font-montserrat-black bg-primary bg-opacity-30 p-4 w-min">
        Experience
      </h4>
      <h5 className="text-3xl font-montserrat-black">
        My professional journey so far
      </h5>
      <div className="flex flex-col gap-6 mt-8 max-w-4xl">
        {experiences.map((exp) => (
          <div
            key={exp.role + exp.date}
            className="relative pl-8 border-l-2 border-primary"
          >
            <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-primary" />
            <p className="text-sm font-montserrat-bold text-primary">{exp.date}</p>
            <h6 className="text-xl font-montserrat-black mt-1">{exp.role}</h6>
            <p className="text-md font-montserrat-bold text-neutral-400">{exp.company}</p>
            <p className="text-lg font-montserrat text-neutral-300 mt-2 text-justify">
              {exp.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
